import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import ar from './locales/ar.json';
import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import { AVAILABLE_UI_LOCALES, localeDirection, type UiLocale } from './supportedLocales';
import tr from './locales/tr.json';

const LOCALE_STORAGE_KEY = 'pairo.admin.locale';

// Admin paneli — tv-app'in aksine cihaz dili algılanmaz (sabit masaüstü/tarayıcı
// bağlamı): kullanıcının localStorage'daki açık seçimi > varsayılan 'tr'.
function initialLanguage(): string {
  try {
    const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored) return stored;
  } catch {
    // localStorage yok/erişilemez — varsayılana düş.
  }
  return 'tr';
}

void i18next.use(initReactI18next).init({
  resources: {
    tr: { translation: tr },
    en: { translation: en },
    de: { translation: de },
    es: { translation: es },
    fr: { translation: fr },
    ar: { translation: ar },
  },
  supportedLngs: [...AVAILABLE_UI_LOCALES],
  lng: initialLanguage(),
  fallbackLng: 'tr',
  interpolation: { escapeValue: false },
});

// <html lang> aktif dille senkron tutulur — index.html'deki sabit "tr",
// EN'e geçince CSS text-transform'un Türkçe kurallarla büyütmesine
// ("Email" -> "EMAİL") yol açıyordu; lang'ı güncellemek bunu düzeltir.
// `dir` de aynı yerden yönetilir (Arapça eklenince tek noktadan çalışsın).
function applyDocumentLocale(lng: string): void {
  document.documentElement.lang = lng;
  document.documentElement.dir = localeDirection(lng);
}
i18next.on('languageChanged', applyDocumentLocale);
applyDocumentLocale(i18next.language);

export function setAdminLocale(locale: UiLocale): void {
  void i18next.changeLanguage(locale);
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // localStorage yazılamıyorsa yalnız bu oturumda dil değişir, kalıcı olmaz.
  }
}

export default i18next;
